export default __webpack_public_path__ + "static/media/Initiate's Cord of Awakening.10097aa2.jpg";